import React from 'react';
import Illustration, { IllustrationProps } from './Illustration';

//
const NoTopologySingleSvg: React.FC<React.SVGProps<SVGSVGElement>> = (
    props
) => {
    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            viewBox="0 0 1002 1002"
        >
            <circle cx="600" cy="402" r="400" fill="#E9ECEF" />
            <path
                d="M600 2C820.914 1.99999 1000 181.086 1000 402"
                stroke="#000216"
                strokeWidth="3"
            />
            <rect
                y="558.592"
                width="747.069"
                height="187.318"
                rx="2.46739"
                fill="#CED4DA"
            />
            <path
                d="M77.5742 629.16C76.7458 629.16 76.0742 629.831 76.0742 630.66C76.0742 631.488 76.7458 632.16 77.5742 632.16V629.16ZM77.5742 632.16H310.922V629.16H77.5742V632.16Z"
                fill="white"
            />
            <path
                d="M77.5742 689.121C76.7458 689.121 76.0742 689.793 76.0742 690.621C76.0742 691.45 76.7458 692.121 77.5742 692.121V689.121ZM77.5742 692.121H632.162V689.121H77.5742V692.121Z"
                fill="white"
            />
            <rect
                x="0.078125"
                y="314.73"
                width="745.601"
                height="181.174"
                rx="2.46739"
                fill="currentColor"
            />
            <path
                d="M79.5664 380.063C78.738 380.063 78.0664 380.735 78.0664 381.563C78.0664 382.392 78.738 383.063 79.5664 383.063V380.063ZM79.5664 383.063H373.486V380.063H79.5664V383.063Z"
                fill="white"
            />
            <path
                d="M79.5664 435.806C78.738 435.806 78.0664 436.478 78.0664 437.306C78.0664 438.135 78.738 438.806 79.5664 438.806V435.806ZM79.5664 438.806H603.438V435.806H79.5664V438.806Z"
                fill="white"
            />
            <rect
                x="0.078125"
                y="813.856"
                width="745.601"
                height="188.142"
                rx="2.46739"
                fill="currentColor"
            />
            <path
                d="M79.5664 886.143C78.738 886.143 78.0664 886.814 78.0664 887.643C78.0664 888.471 78.738 889.143 79.5664 889.143V886.143ZM79.5664 889.143H373.486V886.143H79.5664V889.143Z"
                fill="white"
            />
            <path
                d="M79.5664 948.878C78.738 948.878 78.0664 949.549 78.0664 950.378C78.0664 951.206 78.738 951.878 79.5664 951.878V948.878ZM79.5664 951.878H603.438V948.878H79.5664V951.878Z"
                fill="white"
            />
        </svg>
    );
};
const NoTopologySingle: React.FC<IllustrationProps> = (props) => (
    <Illustration component={NoTopologySingleSvg} {...props} />
);
export default NoTopologySingle;
